import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

export const MissionWrapper = styled.section`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  font: 400 16px / 1.6 ${getToken('font-family-default')};
  color: #fff;
  background: rgb(${getToken('color-background-inverted')});

  /* mobile: the photo sits on top, the text below it */
  &::before {
    content: '';
    display: block;
    height: 280px;
    background: url(/images/about/mission.webp) 62% center / cover no-repeat;
  }

  > div {
    padding: 40px 0 56px;
  }

  ${screen.lg} {
    display: flex;
    align-items: center;
    min-height: clamp(520px, 50vw, 700px);
    padding: 72px 0;
    background: linear-gradient(90deg, #14262b 0%, #202931 60%);

    &::before {
      position: absolute;
      inset: 0 0 0 38%;
      z-index: -1;
      height: auto;
      background: linear-gradient(
          90deg,
          #14262b 0%,
          rgba(20, 38, 43, 0.5) 14%,
          rgba(20, 38, 43, 0) 36%
        ),
        url(/images/about/mission.webp) center / cover no-repeat;
    }

    > div {
      padding: 0;
    }
  }
`;

export const MissionTitle = styled.h2`
  margin: 0;
  font: 700 24px / 1.6 ${getToken('font-family-title')};

  ${screen.lg} {
    max-width: 480px;
    padding: 36px 40px;
    border-radius: 20px;
    background: rgba(18, 30, 36, 0.82);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

export const MissionLabel = styled.span`
  display: block;
  margin-bottom: 16px;
  font: 700 clamp(20px, 2vw, 26px) / 1.5 ${getToken('font-family-title')};
`;

export const MissionText = styled.span`
  display: block;
  font: 700 clamp(28px, 3.4vw, 40px) / 1.25 ${getToken('font-family-title')};
  letter-spacing: -0.015em;
  color: rgb(${getToken('color-brand')});
  text-wrap: balance;
`;
